import { Form, Input } from "antd";
import { useForm } from "antd/lib/form/Form";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { DraggableModal } from "../DraggableModal";
import { EntBasicHB } from "../../models/handBooks/basicHB";

enum FormField {
  nameKy,
  nameRu
}

interface IProps {
  show: boolean;
  item: EntBasicHB;
  onHide: () => void;
  onSubmit: (pos: EntBasicHB) => Promise<boolean>;
}

export const AddHBModal = (props: IProps) => {
  const { t } = useTranslation();
  const [form] = useForm();
  const [loading, setLoading] = useState<boolean>(false);


  useEffect(() => {
	if (props.show) setFieldsFromEntity();
  }, [props.show]);


  const setFieldsFromEntity = (): void => {
	form.setFields([
	  { name: FormField.nameKy, value: props.item.nameKy },
	  { name: FormField.nameRu, value: props.item.nameRu },
	]);
  }

  const setEntityFromFields = (): EntBasicHB => {
	let item = _.cloneDeep(props.item);
	item.nameKy = form.getFieldValue(FormField.nameKy);
	item.nameRu = form.getFieldValue(FormField.nameRu);
	return item;
  }

  const handleSubmit = async () => {
	setLoading(true);
	try {
	  await form.validateFields();
	  const data = setEntityFromFields();
	  const result = await props.onSubmit(data);

	  if (result) props.onHide();
	} finally {
	  setLoading(false);
	}
  }

  return (
	<>
	  <DraggableModal
		title={ props.item.id === 0 ? t('general.add') : t('general.edit') }
		visible={ props.show }
		onCancel={ props.onHide }
		onSubmit={ handleSubmit }
		submitLoading={ loading }
	  >
		<Form
		  initialValues={ { remember: true } }
		  autoComplete="off"
		  layout="vertical"
		  form={ form }
		>
		  <Form.Item
			label={ t('general.nameKy') }
			name={ FormField.nameKy }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		  <Form.Item
			label={ t('general.nameRu') }
			name={ FormField.nameRu }
			rules={ [{ required: true, message: t("msg.fill_in_the_field") }] }
		  >
			<Input autoComplete="off"/>
		  </Form.Item>
		</Form>
	  </DraggableModal>

	</>

  )
}
